import type {
    BridgeRequestEnvelope,
    BridgeResponseEnvelope,
    NestedAppAuthExecutor,
} from 'owa-nested-app-auth-types';
import { processNestedAppAuthResponse } from './processNestedAppAuthResponse';
import { buildFailedBridgeResponseEnvelope } from './buildBridgeResponseEnvelope';
import { buildUnexpectedBridgeError } from './buildUnexpectedBridgeError';

export function processNaaBridgeMessage(
    request: BridgeRequestEnvelope,
    callback: NestedAppAuthExecutor,
    origin: string,
    isTrustedOrigin: boolean,
    targetWindow: Window
): Promise<BridgeResponseEnvelope> {
    switch (request.method) {
        case 'GetToken':
            if (request.tokenParams) {
                return processNestedAppAuthResponse(
                    request.requestId,
                    callback.getTokenRequest(request.tokenParams, origin)
                );
            }
            break;

        case 'GetTokenPopup':
            if (request.tokenParams) {
                return processNestedAppAuthResponse(
                    request.requestId,
                    callback.getTokenPopup(request.tokenParams, origin, targetWindow)
                );
            }
            break;

        case 'GetInitContext':
            return processNestedAppAuthResponse(
                request.requestId,
                callback.getInitContext(isTrustedOrigin).then(initContext => ({ initContext }))
            );
    }

    return Promise.resolve(
        buildFailedBridgeResponseEnvelope(
            request.requestId,
            buildUnexpectedBridgeError(
                'unknown_request_method',
                `Unknown request method: ${request.method}`
            )
        )
    );
}
